import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { AppComponent } from "./app.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NAV_DROPDOWN_DIRECTIVES } from "./shared/nav-dropdown.directive";

import { ChartsModule } from "ng2-charts/ng2-charts";
import { SIDEBAR_TOGGLE_DIRECTIVES } from "./shared/sidebar.directive";
import { AsideToggleDirective } from "./shared/aside.directive";
import { BreadcrumbsComponent } from "./shared/breadcrumb.component";

import { AuthGuard } from "./services/auth.guard";
import { AuthenticationService } from "./services/authentication.service";
import { IdentityService } from "./services/identity.service";
import { Storage } from "./services/storage.service";
import { AdministrationService } from "./administration/administration.service";
import { EntryService } from "./entry/entry.service";
import { DashboardService } from "./dashboard/dashboard.service";

// angular2-jwt config for JiT and AoT compilation.
import { AuthHttp, AuthConfig } from "angular2-jwt";
import { Http } from "@angular/http";

// Routing Module
import { AppRoutingModule } from "./app.routing";

//Layouts
import { LoginLayoutComponent } from "./layouts/login-layout.component";
import { FullLayoutComponent } from "./layouts/full-layout.component";

// Set tokenGetter to use the same storage in AuthenticationService.Helpers.
export function getAuthHttp(http: Http) {
  return new AuthHttp(
    new AuthConfig({
      noJwtError: true,
      tokenGetter: () => localStorage.getItem("id_token"),
    }),
    http
  );
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    LoginLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    AuthGuard,
    AuthenticationService,
    IdentityService,
    {
      provide: AuthHttp,
      useFactory: getAuthHttp,
      deps: [Http],
    },
    Storage,
    AdministrationService,
    EntryService,
    DashboardService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
